import { FRONTEND_CONFIG } from '~app/config';

type ClarityFn = ((...args: unknown[]) => void) & {
  q?: unknown[][];
};

declare global {
  interface Window {
    clarity?: ClarityFn;
  }
}

export function initClarity() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  const projectId = FRONTEND_CONFIG.VITE_CLARITY_PROJECT_ID;
  const enabled = FRONTEND_CONFIG.VITE_CLARITY_ENABLED;

  if (!projectId || !enabled) return;

  if (document.getElementById('clarity-script')) return;

  window.clarity =
    window.clarity ||
    ((...args: unknown[]) => {
      const clarityQueue = window.clarity?.q || [];

      clarityQueue.push(args);

      if (window.clarity) {
        window.clarity.q = clarityQueue;
      }
    });

  const script = document.createElement('script');
  script.async = true;
  script.id = 'clarity-script';
  script.src = `https://www.clarity.ms/tag/${projectId}`;

  const firstScript = document.getElementsByTagName('script')[0];
  firstScript?.parentNode?.insertBefore(script, firstScript);
}
